module.exports = __webpack_public_path__ + "img/b_AnevilSirop_2.5bc3da73.jpeg";